import React from 'react';
import {
  Marker,
  Popup,
  useMap
} from "react-leaflet";
import L from 'leaflet';
import { menu2icon } from './config';

/**
 * 道路台帳付図のポップアップ
 * @param spot
 * @param latitude
 * @param longitude
 * @param menu
 * @param draggable
 * @param option
 * @returns {JSX.Element|null}
 * @constructor
 */
const Component = ({spot, latitude, longitude, menu, draggable=false, option}) => {

  const getIcon = (spot) => {

    // デフォルト
    let icon = menu2icon["vis_92"];

    const target = spot["管理区分"];
    
    return new L.Icon({
      iconUrl: icon,
      iconRetinaUrl: icon,
      iconSize: [35, 35],
      iconAnchor: [17, 23],
      popupAnchor: [0, -50]
    })

  };
  
  const map = useMap()
  const bounds = map.getBounds()
  const minlat = bounds._southWest.lat
  const maxlat = bounds._northEast.lat
  const minlng = bounds._southWest.lng
  const maxlng = bounds._northEast.lng

  const handleSpotData = (menu, spot) => {

    // URLに含まれる92_2026などを差し替えるためenvを使用してURLを作成。
    const fileUrl = process.env.REACT_APP_DATA_92_BASE_URL+spot["ファイル"];
    
    let ret = []
    
    ret.push(<dl className='dl-list is-modal-spot'><dt>路線種</dt><dd>{spot["路線種"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>路線名</dt><dd>{spot["路線名"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>路線番号</dt><dd>{spot["路線番号"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>管理事務所名</dt><dd>{spot["管理事務所名"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>道路台帳図番</dt><dd>{spot["道路台帳図番"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>ファイル</dt><dd>{ spot["ファイル"] && <a href={fileUrl} target={"_blank"}>{fileUrl}</a>}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>緯度</dt><dd>{spot["緯度"]}</dd></dl>)
    ret.push(<dl className='dl-list is-modal-spot'><dt>経度</dt><dd>{spot["経度"]}</dd></dl>)

    return ret

  }

  if(latitude > minlat && latitude < maxlat && longitude > minlng && longitude < maxlng){

    return (
      <>
        <Marker
          key={latitude + "_" +longitude}
          position={[latitude, longitude]}
          icon={getIcon(spot)}
        >
          <Popup autoPan={false}  minHeight={300} maxHeight={400} minWidth={500} closeOnClick>
            {
              handleSpotData(menu, spot)
            }
          </Popup>
        </Marker>

      </>
    );
  }else{
    return null
  }
}

export default Component;
